import React, { useState, useEffect } from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';
// 图片处理
import { getThumbnail } from '@src/common/utils';
import { formatImage } from '@src/common/formatImage';
// 信息流组件
import { NewsStream } from '@ifeng-fe/news-stream';
import '@ifeng-fe/news-stream/lib/NewsStream/style/news-stream-global.css';
import styles from './index.css';
// 文章评论请求
import { getCommentCount, getNewInfoIndexList, formatNewsstream } from '../services/api';
// 碎片组件
import Chip from 'Chip';
// 组件
import NavLong from '../NavLong';
import Content from './Content';

const FocusNews = ({ content }) => {

    const { focusNews, focusNewsTitle } = content;

    // 信息流配置
    const newsStreamProps = {
        content: formatNewsstream(focusNews, '1-305612-'), // 截取信息流条20条
        columnId: '1-305612-', // 加载更多时的碎片ID
        isEnd: !(focusNews && focusNews.length > 20), // 是否已显示全部，true：已显示全部，false：还有数据
        isDisplaySource: true, // 是否显示新闻来源
        repeatedID: [], // 信息流内用于排重的id
        ad: [{}],
        dataTypeName: 'dynamicFragment'
    };

return (
        <div className={styles.wrap}>
            <Chip 
                key="focusNewsTitle"
                id="260163"
                name="focusNewsTitle"
                type="struct"
                title="双碳要闻"
                groupName="双碳要闻"
                content={focusNewsTitle}
            >
                    <NavLong />
            </Chip>

            <div className={styles.newsItem}>
                <NewsStream {...newsStreamProps} />
                {/* <Content content={ focusNews } /> */}
            </div>
    
        </div>
    );
};

FocusNews.propTypes = {
    content: PropTypes.object,
};
export default errorBoundary(FocusNews);
